import React from 'react'
import PropTypes from 'prop-types'

import MagazineCTA from '@/component/Primitive/MagazineCTA'

const MagazineCtaWidget = ({ latestMagazineIssue, variation }) => {
  if (!latestMagazineIssue) return null

  const widgetProps = {
    to: '/magazine',
    as: `/magazine/${latestMagazineIssue.slug}`,
    title: 'Read the latest Digital Magazine today!',
    imageUrl: latestMagazineIssue.images?.cover_321x446_150?.[0]?.url,
    variation
  }

  return <MagazineCTA {...widgetProps} />
}

MagazineCtaWidget.propTypes = {
  latestMagazineIssue: PropTypes.object,
  variation: PropTypes.string
}

export default MagazineCtaWidget
